import sweetalert from "sweetalert2";

const swal = {
  fire: (options) => {
    return sweetalert.fire({
      ...options,
      confirmButtonColor: '#ed1f26',
      customClass: {
        container: 'swal-z'
      }
    })
  }
}

export default swal;